// Homepage "Popular Categories" showcase — gives the three core focus
// areas (JAMB, WAEC/NECO, Adult Education) visual prominence and links
// straight into the pretty SEO landing routes built for #17.
import React from "react";
import { Link } from "react-router-dom";
import "./PopularCategoriesSection.css";

const CATEGORIES = [
  {
    key: "jamb",
    title: "JAMB",
    description: "UTME prep across Science, Arts & Social Science",
    href: "/tutors/jamb",
    icon: "🎓",
  },
  {
    key: "waec",
    title: "WAEC / NECO",
    description: "SSCE prep across Science, Arts & Commercial",
    href: "/tutors/waec",
    icon: "📘",
  },
  {
    key: "adult-education",
    title: "Adult Education",
    description: "Reading, writing, spelling & public speaking",
    href: "/adult-education",
    icon: "📖",
  },
];

const PopularCategoriesSection = () => (
  <section className="popular-categories-section">
    <div className="popular-categories-container">
      <h2 className="popular-categories-title">Popular Categories</h2>
      <p className="popular-categories-subtitle">
        TutorsLinks&rsquo; most requested exam prep and learning tracks
      </p>

      <div className="popular-categories-grid">
        {CATEGORIES.map((cat) => (
          <Link key={cat.key} to={cat.href} className="popular-category-card">
            <span className="popular-category-icon" aria-hidden="true">
              {cat.icon}
            </span>
            <h3 className="popular-category-name">{cat.title}</h3>
            <p className="popular-category-desc">{cat.description}</p>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default PopularCategoriesSection;
